import { SPA_BUILD_ID } from '@/config/appBuild'

export type SpaBuildMeta = { build_id: string }

function apiBase(): string {
  const endpoint = process.env.VUE_APP_API_ENDPOINT || ''
  return endpoint.replace(/\/$/, '')
}

/** Публичная мета выкладки SPA (сравнение с вшитым SPA_BUILD_ID — тёплое обновление). */
export async function fetchSpaBuildMeta(): Promise<SpaBuildMeta | null> {
  try {
    const bust = `_=${Date.now()}`
    const res = await fetch(`${apiBase()}/api/meta/spa-build?${bust}`, {
      method: 'GET',
      cache: 'no-store',
      credentials: 'omit',
      headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    })
    if (!res.ok) {
      return null
    }
    const data = (await res.json()) as { build_id?: unknown }
    const build_id =
      typeof data.build_id === 'string' && data.build_id.trim() !== '' ? data.build_id.trim() : null
    if (build_id == null) {
      return null
    }
    return { build_id }
  } catch {
    return null
  }
}

/** URL service worker с версией выкладки (cache-bust при новом билде). */
export const CRM_SERVICE_WORKER_URL = `${process.env.BASE_URL || '/'}service-worker.js?v=${encodeURIComponent(SPA_BUILD_ID)}`

export function isStandalonePwaMode(): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  const nav = window.navigator as Navigator & { standalone?: boolean }
  return window.matchMedia('(display-mode: standalone)').matches || nav.standalone === true
}
